import { ChangeEvent, useState } from "react";

const Login = () => {
	const [username, setUsername]  = useState("")
	const [password, setPassword] = useState("")

	const handleUsername = (event: ChangeEvent<HTMLInputElement>) => {
		setUsername(event.target.value)
	}

	const handlePassword = (event: ChangeEvent<HTMLInputElement>) => {
		setPassword(event.target.value)
	}

	const attemptLogin = async () => {
		if (username !== "" && password !== "") {
			const payload = {"email": username, "password": password}
			try{
				const response = await fetch(process.env.REACT_APP_API+"/api/login", {
					method: "POST",
					body: JSON.stringify(payload),
					credentials: 'include'
				})
				const result = await response.json()
				const userID = result.userID
				localStorage.setItem("userID", userID)
				const unitResponse = await fetch(process.env.REACT_APP_API+"/api/defaultUnitByUser?userID="+userID)
				const unitResult = await unitResponse.json()
				const locationResponse = await fetch(process.env.REACT_APP_API+"/api/locationsForUser?userID="+userID)
				const locationResult = await locationResponse.json()
				
				if (unitResult && unitResult.id) {
					localStorage.setItem("defaultUnit", unitResult.id)
					localStorage.setItem("defaultLocation", locationResult[0].id)
				}
			} catch(e) {
				console.log(e)
			}
			window.location.reload()
		}
	}

	return (
		<div className="resilire">
			<nav>
				<h1>Login</h1>
			</nav>
			<label htmlFor="username">Username</label>
			<input id="username" name="username" onChange={handleUsername}></input>
			<label htmlFor="password">Password</label>
			<input type="password" id="password" name="password" onChange={handlePassword}></input>
			<button onClick={attemptLogin}>Login</button>
		</div>
	)
};
export default Login;
